import { CompanyType, useOrganizations } from './useOrganizations';

export const useIsMemberOfAccountingFirm = () => {
  const { data: organizations = [] } = useOrganizations();

  return organizations.some((org) => org.companyType === CompanyType.AccountingFirm);
};
